<template>
  <g>
    <circle :cx="center" :cy="center" :r="radius" stroke="#b1b1b1" stroke-width="1" :fill="material.color.hex"/>
    <g v-if="sides.a.rand === saum">
      <circle :cx="sides.a.saum.center" :cy="sides.a.saum.center" :r="sides.a.saum.radius" stroke="#b1b1b1" stroke-width="1" stroke-dasharray="3,3" :fill="material.color.hex"/>
      <g v-if="sides.a.rand.oesenArt != inactiveOesen">
        <circle v-for="(item, index) in sides.a.oesenAnzahl" :key="index" :cx="sides.a.oesenAbstand.x(index, sides.a.oesenAnzahl)" :cy="sides.a.oesenAbstand.y(index, sides.a.oesenAnzahl)" r="3" stroke="#b1b1b1" stroke-width="2" fill="#fff" />
      </g>
    </g>
    <circle v-if="sides.a.rand === hohlsaum" :cx="sides.a.hohlsaum.center" :cy="sides.a.hohlsaum.center" :r="sides.a.hohlsaum.radius" stroke="#b1b1b1" stroke-width="1" :fill="material.color.hex"/>
    <circle :cx="center" :cy="center" :r="radiusBorder" stroke="#353535" stroke-width="1" fill="none" />
    <polygon :points="sides.a.border.corner.start" :transform="sides.a.border.corner.rotateStart" stroke="#353535" stroke-width="1" fill="#353535"/>
    <polygon :points="sides.a.border.corner.end" :transform="sides.a.border.corner.rotateEnd" stroke="#353535" stroke-width="1" fill="#353535"/>
    <rect :x="sides.a.border.rect.x" :y="sides.a.border.rect.y" :width="sides.a.border.rect.width" :height="sides.a.border.rect.height" style="fill:#fff" />
    <text :x="sides.a.labelSpace.x" :y="sides.a.labelSpace.y" font-weight="bold" font-family="sans-serif" font-size="2.5em" fill="#232323">{{sides.a.name}}</text>
  </g>
</template>

<script>
import DataRand from '../../../../../data/main/config/setup/rand/randArt'

export default {
  props: ['material', 'rand'],
  data () {
    return {
      center: 350 / 2 + 75,
      radius: 350 / 2,
      radiusBorder: 350 / 2 + 20,
      saum: DataRand.randArt.saum.titleSaum.name,
      hohlsaum: DataRand.randArt.hohlsaum.title.name,
      inactiveOesen: DataRand.randArt.saum.optionsOesenart[0].value.oesenArt
    }
  },
  computed: {
    sides () {
      return {
        a: {
          name: 'a',
          rand: this.rand.a.type,
          oesenAnzahl: this.rand.a.type === this.saum ? this.rand.a.oesenAnzahl : 0,
          oesenAbstand: {
            radius: 350 / 2 - 15,
            center: 350 / 2 + 75,
            x: function (i, item) {
              return Math.cos(((360 / item) * (Math.PI / 180)) * i) * this.radius + this.center
            },
            y: function (i, item) {
              return Math.sin(((360 / item) * (Math.PI / 180)) * i) * this.radius + this.center
            }
          },
          saum: {
            center: this.center,
            radius: this.radius - 30
          },
          hohlsaum: {
            center: this.center,
            radius: this.radius - 9
          },
          labelSpace: {
            x: 15,
            y: 260
          },
          border: {
            rect: {
              x: 440,
              y: 249,
              width: 10,
              height: 2
            },
            corner: {
              start: '445,248 440,238 450,238',
              rotateStart: 'rotate(-2, 445, 248)',
              end: '445,252 440,262 450,262',
              rotateEnd: 'rotate(2, 445, 252)'
            }
          },
          id: 1
        }
      }
    }
  }
}
</script>

<style>
</style>
